/* global axios */
import ApiClient from './ApiClient';

class LeadCaptureEndpoints extends ApiClient {
  constructor() {
    super('lead_capture_endpoints', { accountScoped: true });
  }

  rotateSlug(id) {
    return axios.post(`${this.url}/${id}/rotate_slug`);
  }

  stats(id) {
    return axios.get(`${this.url}/${id}/stats`);
  }

  // Importa os campos de um formulario Meta Lead Ads (key/label/tipo/opcoes)
  // pra montar a qualificacao por opcao + placeholders sem digitar na mao.
  getFormFields(formId) {
    return axios.get(`${this.url}/form_fields`, {
      params: { form_id: formId },
    });
  }

  // Phase C-4: lista os leads que entraram por formulario + respostas + termometro.
  getLeads() {
    return axios.get(`${this.url}/leads`);
  }

  // Cria endpoint com upload opcional de imagem (multipart). Usa FormData
  // pra enviar tanto os campos JSON quanto o arquivo numa requisicao so.
  createWithImage(payload, imageFile) {
    const fd = new FormData();
    Object.entries(payload).forEach(([k, v]) => {
      if (v === null || v === undefined) return;
      if (Array.isArray(v) || typeof v === 'object') {
        fd.append(`lead_capture_endpoint[${k}]`, JSON.stringify(v));
      } else {
        fd.append(`lead_capture_endpoint[${k}]`, v);
      }
    });
    if (imageFile) fd.append('welcome_image', imageFile);
    return axios.post(this.url, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  updateWithImage(id, payload, imageFile, removeImage) {
    const fd = new FormData();
    Object.entries(payload).forEach(([k, v]) => {
      if (v === null || v === undefined) return;
      if (Array.isArray(v) || typeof v === 'object') {
        fd.append(`lead_capture_endpoint[${k}]`, JSON.stringify(v));
      } else {
        fd.append(`lead_capture_endpoint[${k}]`, v);
      }
    });
    if (imageFile) fd.append('welcome_image', imageFile);
    if (removeImage) fd.append('remove_welcome_image', 'true');
    return axios.patch(`${this.url}/${id}`, fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export default new LeadCaptureEndpoints();
